import React from "react";
import Link from 'gatsby-link'

export default ({ data }) => {
  console.log(data);

  return (
    <div className="ContentsContainer PostContainer">
      <h2>
        Moviendo el mundo
        <br/>
        <span>{data.allMarkdownRemark.totalCount} Posts</span>
      </h2>
      <div className="PostContent">
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <Link className="PostLink" key={node.id} to={node.fields.slug}>
            <div className="PostStyle" style={{ marginTop: '30px'}}>
              <img className="PostImage" src={node.frontmatter.image} alt=""/>
              <h3>
               {node.frontmatter.title}{" "} <br/>
                <span color="#BBB"> {node.frontmatter.by} / {node.frontmatter.date}</span>
              </h3>
              <p>{node.excerpt} {node.frontmatter.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};



export const query = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            description
            by
            image
          }
          fields {
            slug
          }
          excerpt
        }
      }
    },
    allFooterComponentData {
        edges {
          node {
            id
          }
        }
      }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/blog.js